// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"1b8e3397","977":"99222045"}[chunkId] + ".chunk.js";
};